module.exports = __webpack_public_path__ + "static/media/Growing tray for microgreens or Fodder tray4.8c67a8db.webp";